import React from "react";
import * as actions from "../actions/actions";
import { connect } from "react-redux";

import { hashHistory } from "react-router";

let number_with_commas = require("./../legacy/helpers/number_with_commas")
    .default;

class PluginFooter extends React.Component {
    showSignup(e) {
        e.preventDefault();
        hashHistory.push(`signup`);
    }

    previousPage() {
        let page = parseInt(this.props.page) - 1;
        if (page === 0) {
            page = 1;
        }
        this.props.setPage(page);
    }

    nextPage() {
        let page = parseInt(this.props.page) + 1;
        this.props.setPage(page);
    }

    renderPagination() {
        let pagination, pageStart, pageEnd;

        if (this.props.totalIcons) {
            pageStart = this.props.page * 100 - 99;

            if (this.props.page * 100 < this.props.totalIcons) {
                pageEnd = this.props.page * 100;
            } else {
                pageEnd = this.props.totalIcons;
            }

            pagination = (
                <div
                    className="arrow-container weight-light"
                    style={{
                        display: "flex",
                        margin: "auto",
                        width: "100%",
                        justifyContent: "space-between",
                        maxWidth: "600px"
                    }}
                >
                    <div
                        className={`pagination-arrow left-arrow ui_left-arrow ${this
                            .props.page === "1"
                            ? "disabled"
                            : ""}`}
                        onClick={this.previousPage.bind(this)}
                    />
                    <div className="text-container">
                        {`${number_with_commas(pageStart)}-${number_with_commas(
                            pageEnd
                        )} of ${number_with_commas(
                            this.props.totalIcons
                        )} icons`}
                    </div>
                    <div
                        className={`pagination-arrow right-arrow ui_right-arrow ${Math.ceil(
                            this.props.totalIcons / 100
                        ) === parseInt(this.props.page)
                            ? "disabled"
                            : ""}`}
                        onClick={this.nextPage.bind(this)}
                    />
                </div>
            );
        }

        if (this.props.loading) {
            pagination = null;
        }

        return pagination;
    }

    renderCustomerService() {
        let customerServiceURl = "/help/plug-ins/";

        if (this.props.host === "office") {
            customerServiceURl = "/help/office365-add-in/";
        }
        if (this.props.host === "adobe") {
            customerServiceURl = "/help/adobe-add-on/";
        }

        let customerService = (
            <div
                className="weight-light"
                style={{
                    display: "flex",
                    alignItems: "center",
                    margin: "auto",
                    width: "100%",
                    padding: "8px 16px",
                    justifyContent: "space-between",
                    maxWidth: "600px"
                }}
            >
                <a
                    href={customerServiceURl}
                    style={{
                        textDecoration: "underline",
                        color: "#000000"
                    }}
                    target="_blank"
                    onClick={window.handleLink.bind(this)}
                >
                    Customer Support
                </a>
                <span className="font-xsmall">
                    {"© Noun Project Inc."}
                </span>
            </div>
        );
        return customerService;
    }

    render() {
        let footerContent;

        if (this.props.showPagination) {
            footerContent = this.renderPagination();
        } else {
            footerContent = this.renderCustomerService();
        }

        return (
            <div
                className="plugin-footer-spacer"
                style={{
                    height: "0",
                    position: "relative"
                }}
            >
                <style>{`
                    .arrow-container .text-container{
                        display: flex;
                        text-align: center;
                        justify-content: center;
                        align-items: center;
                    }
                    .arrow-container .disabled {
                        pointer-events: none;
                        opacity: 0.2;
                    }
                    .pagination-arrow{
                        flex-grow: 1;
                        padding: 20px;
                        display: flex;
                    }
                    .pagination-arrow.right-arrow{
                        justify-content: flex-end;
                    }
                `}</style>
                <div
                    className="plugin-footer"
                    style={{
                        position: "fixed",
                        bottom: "0px",
                        left: "0px",
                        width: "100%",
                        background: "#F4F4F4",
                        color: "#000000",
                        height: "50px",
                        zIndex: "11",
                        alignItems: "center",
                        display: "flex"
                    }}
                >
                    {footerContent}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let currentUser,
        host = state.plugin.host,
        page = state.plugin.page,
        totalIcons = state.icons.search_total;

    if (state.user.is_anonymous !== undefined) {
        currentUser = state.user;
    }

    return {
        currentUser,
        host,
        page,
        totalIcons
    };
}

module.exports = connect(mapStateToProps, {
    setPage: actions.setPage
})(PluginFooter);
